export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: '¿Cómo recibo el material?',
    answer:
      'Al completar la compra recibís un email con el enlace de descarga. El acceso es inmediato.',
  },
  {
    question: '¿Sirve si soy docente principiante?',
    answer:
      'Sí, está diseñado para docentes de todos los niveles de experiencia.',
  },
  {
    question: '¿Para qué niveles educativos sirve?',
    answer:
      'Para primaria y secundaria completas — de 1° a 6° año en ambos niveles.',
  },
  {
    question: '¿Los bonos están incluidos en el precio?',
    answer: 'Sí, los 5 bonos están incluidos sin costo adicional.',
  },
  {
    question: '¿En qué formato están los archivos?',
    answer:
      'Todos los tomos y bonos son en formato PDF, listos para imprimir o usar en pantalla.',
  },
  {
    question: '¿Tengo que pagar una mensualidad?',
    answer: 'No. Es un único pago y el acceso es de por vida.',
  },
  {
    question: '¿Qué pasa si no me gusta?',
    answer:
      'Tenés 7 días de garantía. Si no es lo que esperabas te devolvemos el dinero sin preguntas.',
  },
]
